import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { response } from 'src/app/app.service';
import { environment as env } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BookingService {

    constructor(private http: HttpClient) { }


    // paymentGenerate
    // /api/Payment/generateCheckoutId
    paymentGenerateCheckOutId = (req: FormData) => this.http.post<response>(env.baseUrl + "Payment/generateCheckoutId", req)

    // DateSlot
    getDatSlot = (obj) => this.http.get<any>(env.baseUrl + "DaySlot?", { params: obj })

    // Visit
    postVisit = (req: FormData) => this.http.post<response>(env.baseUrl + "Visit", req)

    // promoCode
    // /api/promoCode/123?serviceId=321
    getPromoCode = (req: string) => this.http.get<response>(env.baseUrl + "promoCode/" + req);

    // <lookUps>

    // Symptom
    getSymptom = (id: number) => this.http.get<response>(env.baseUrl + "Symptom?MedicalServiceId=" + id)

    // Relatives
    getRelatives = () => this.http.get<response>(env.baseUrl + "Relative");


    // </lookUps>


}